import gql from 'graphql-tag';

const CREATE_USAGE_SHEET_AFTER_SFID = gql`
  mutation createUsageSheetAfterSfid(
    $caseSFID: String
    $caseId: String
    $caseExternalId: String
    $eventExternalId: String
    $division: String
    $branchId: String!
    $accountId: String!
    $procedureTypeIds: String
    $surgeonId: String
    $salesRepId: String!
    $eventType: String
    $shipToId: String
    $billToId: String
    $eventDateTime: Date
    $poNumber: String
    $patientId: String
    $formType: String!
    $shipMethod: String
    $requestedFrom: String
    $comments: [Comment]
    $lineItems: [InventoryLineItem]
    $attachments: [Attachment]
  ) {
    createUsageSheetAfterSfid(
      caseSFID: $caseSFID
      division: $division
      caseId: $caseId
      caseExternalId: $caseExternalId
      eventExternalId: $eventExternalId
      branchId: $branchId
      accountId: $accountId
      procedureTypeIds: $procedureTypeIds
      surgeonId: $surgeonId
      salesRepId: $salesRepId
      eventType: $eventType
      eventDateTime: $eventDateTime
      shipToId: $shipToId
      billToId: $billToId
      poNumber: $poNumber
      patientId: $patientId
      formType: $formType
      shipMethod: $shipMethod
      requestedFrom: $requestedFrom
      comments: $comments
      lineItems: $lineItems
      attachments: $attachments
    ) {
      message
      externalId
      sfid
    }
  }
`;

export default CREATE_USAGE_SHEET_AFTER_SFID;
